import React, { SVGProps } from "react";

export default function SupXSmall(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.99993 10.7071L13.889 14.5962L14.5961 13.8891L10.707 10L14.5961 6.11091L13.889 5.40381L9.99993 9.29289L6.11084 5.40381L5.40374 6.11091L9.29282 10L5.40374 13.8891L6.11084 14.5962L9.99993 10.7071Z"
        fill="currentColor"
      />
    </svg>
  );
}
